"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRenameWorkspaceRequestStatus = exports.getAddWorkspaceMembersRequestStatus = exports.getDeleteWorkspaceMembersRequestStatus = exports.getCreateWorkspaceRequestStatus = exports.getDeleteWorkspaceRequestStatus = exports.getFetchPayloadRequestStatus = void 0;

var _PayloadActions = require("../actions/PayloadActions");

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getFetchPayloadRequestStatus = (0, _getRequestStatus.default)(_PayloadActions.PayloadActionTypes.FETCH_PAYLOAD);
exports.getFetchPayloadRequestStatus = getFetchPayloadRequestStatus;
var getDeleteWorkspaceRequestStatus = (0, _getRequestStatus.default)(_WorkspaceActions.WorkspaceActionTypes.DELETE_WORKSPACE);
exports.getDeleteWorkspaceRequestStatus = getDeleteWorkspaceRequestStatus;
var getCreateWorkspaceRequestStatus = (0, _getRequestStatus.default)(_WorkspaceActions.WorkspaceActionTypes.CREATE_WORKSPACE);
exports.getCreateWorkspaceRequestStatus = getCreateWorkspaceRequestStatus;
var getDeleteWorkspaceMembersRequestStatus = (0, _getRequestStatus.default)(_WorkspaceActions.WorkspaceActionTypes.DELETE_WORKSPACE_MEMBERS);
exports.getDeleteWorkspaceMembersRequestStatus = getDeleteWorkspaceMembersRequestStatus;
var getAddWorkspaceMembersRequestStatus = (0, _getRequestStatus.default)(_WorkspaceActions.WorkspaceActionTypes.ADD_WORKSPACE_MEMBERS);
exports.getAddWorkspaceMembersRequestStatus = getAddWorkspaceMembersRequestStatus;
var getRenameWorkspaceRequestStatus = (0, _getRequestStatus.default)(_WorkspaceActions.WorkspaceActionTypes.RENAME_WORKSPACE);
exports.getRenameWorkspaceRequestStatus = getRenameWorkspaceRequestStatus;